import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'
import { RichTextFormField } from 'components/RichTextEditor'

const IFrame = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='URL'>
        <Textfield
          placeholder='https://adobe.com'
          name='frameUrl'
          value={content.frameUrl || ''}
          onChange={onChange('frameUrl')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Feature policy directives'>
        <Textfield
          placeholder='e.g. camera; microphone;'
          name='featurePolicy'
          value={content.featurePolicy || ''}
          onChange={onChange('featurePolicy')}
          disabled={disabled}
        />
      </FieldLabel>

      <Switch label='Full width' checked={!!content.fullWidth} onChange={v => !disabled && onChange('fullWidth')(v)} />
    </>
  )
}

export default [{ label: 'iFrame', content: IFrame }]
